import { VcsProvider } from "types/generated";

export const getCommitDigitsCount = (provider: VcsProvider) => {
  return provider === VcsProvider.Gitlab ? 8 : 7;
};
